import * as React from "react"
import { Modal, Button } from "react-bootstrap"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
import CustomizableColumn from "./CustomizableColumn"
import DroppableContainer from "./Container"

interface ColumnsCustomizeModalProps {
  show: boolean
  columns: CustomizableColumn[]
  storeKey?:string
  onSave: (columns: CustomizableColumn[]) => void
  onClose: () => void
}

interface ColumnsCustomizeModalState {
  columns: CustomizableColumn[]
}

export default class ColumnsCustomizeModal extends React.Component<ColumnsCustomizeModalProps, ColumnsCustomizeModalState> {
  state: ColumnsCustomizeModalState = {
    columns: [...this.props.columns]
  }

  handleChangeColumnsList = (columns: CustomizableColumn[]) => this.setState({ columns: columns })

  handleVisibilityChange = (name: string, visible: boolean) => {
    let newColumns = this.state.columns.map(column => {
      if (name === column.name) {
        return { ...column, visible: visible }
      }
      return column
    })

    this.setState({ columns: newColumns })
  }

  handleClose = () => {
    this.setState({ columns: this.props.columns })
    this.props.onClose()
  }
  handleSave = () => {
    const key = this.props.storeKey || "";
    saveCustomized(key, this.state.columns);
    this.props.onSave(this.state.columns);
  }

  render() {
    return <Modal backdrop="static" size="xl" centered show={this.props.show} onHide={this.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>CUSTOMIZE COLUMNS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="pb-2">Select columns you wish to view. Drag and drop columns to change the viewing order.</div>
        <DndProvider backend={HTML5Backend}>
          <DroppableContainer columns={this.state.columns} onChangeColumnsList={this.handleChangeColumnsList} onVisibilityChange={this.handleVisibilityChange} />
        </DndProvider>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => this.handleClose()}>CANCEL</Button>
        <Button variant="primary" onClick={() => this.handleSave()}>CUSTOMIZE</Button>
      </Modal.Footer>
    </Modal >
  }
}

export function saveCustomized(key: string, columns: CustomizableColumn[]) {
  if (!key) {
    return columns;
  }
  const datStr = JSON.stringify(columns)
  localStorage.setItem(key, datStr)
}

export function loadCustomized(key: string, defaultColumns: CustomizableColumn[]) {
  if (!key) {
    return defaultColumns
  }
  const datStr = localStorage.getItem(key);

  if (!datStr) {
    saveCustomized(key, defaultColumns);
    return defaultColumns
  }
  const savedColumns: CustomizableColumn[] = JSON.parse(datStr);

  if (validate(savedColumns, defaultColumns)) {
    return savedColumns
  }
  else {
    saveCustomized(key, defaultColumns);
    return defaultColumns
  }
}

function validate(savedColumns: CustomizableColumn[], defaultColumns: CustomizableColumn[]) {
  if (savedColumns.length !== defaultColumns.length) return false
  const columnNames: string[] = savedColumns.map(col => col.name)
  const columLabels: string[] = savedColumns.map(col => col.label || "")
  return defaultColumns.every(col => columnNames.includes(col.name) && columLabels.includes(col.label || ""))
}
